module.exports = __webpack_public_path__ + "img/security.9d2bf8c5.png";